import { render } from "./aboutView.vue?vue&type=template&id=48c7ac0e"
const script = {}

import "./aboutView.vue?vue&type=style&index=0&id=48c7ac0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__